/*
 * File: /src/components/metafields-edit/MetafieldEditTextarea.1.vue
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Monday, 30th July 2018 11:36:35 am
 * Last Modified: Monday, 6th August 2018 3:21:53 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
<template>
  <div class="metafield-edit-wysiwyg">
    <BaseWysiwyg
      :value="value"
      :label="field.label"
      :hint="hint"
      @input="onInput"
      ></BaseWysiwyg>
  </div>
</template>

<script>
import { forSingleMetafield } from '@/mixins/metafields-changed-detection.mixin'

export default {
  mixins: [ forSingleMetafield(true) ],
  props: {
    field: Object,
    value: String,
    hint: String
  },
  methods: {
    onInput (val) {
      this.$emit('input', val === '' ? null : val)
    }
  },
}
</script>

<style lang="scss">
  .metafield-edit-wysiwyg {
    // b {
    //   font-weight: bold;
    // }

    // i:not(.mce-ico) {
    //   font-style: italic;
    // }

    // ul { 
    //   list-style-type: disc; 
    //   list-style-position: inside; 
    // }

    // ol { 
    //   list-style-type: decimal; 
    //   list-style-position: inside; 
    // }

    // ul ul, ol ul { 
    //   list-style-type: circle; 
    //   list-style-position: inside; 
    //   margin-left: 15px; 
    // }

    // ol ol, ul ol { 
    //   list-style-type: lower-latin; 
    //   list-style-position: inside; 
    //   margin-left: 15px; 
    // }
  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditWysiwyg.vue